"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSolarSolutions = function IconSolarSolutions(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M22 8V5H11v2h9v1H8v11l-.007.123C7.885 20.103 6.5 21 5 21v2l.217-.004c1.337-.05 2.633-.555 3.538-1.37q.15.196.327.372l.163.154a3.74 3.74 0 0 0 2.632.939l.134-.01.139.006a3.8 3.8 0 0 0 2.868-1.25q.054.057.11.112l.162.148a3.75 3.75 0 0 0 1.71.84V41H7.002q1.07 1.07 2.268 2H19V22.944a3.73 3.73 0 0 0 2.997-3.939L22 9zm-12 2v9.08l-.003.062-.01.142a1.74 1.74 0 0 0 1.74 1.81l.173-.009.17-.003a1.81 1.81 0 0 0 1.926-1.608 3 3 0 0 1-.004-.187L14 19.08V10zm6.003 9.443a4 4 0 0 0-.005-.43L16 10h4v9.08l.005.192a1.75 1.75 0 0 1-.52 1.252 1.73 1.73 0 0 1-1.383.481h-.195l-.17.007a1.75 1.75 0 0 1-1.214-.496l-.116-.124a1.75 1.75 0 0 1-.404-.949m-6.58 7.493 5.07 5.07-.707.708-5.07-5.07zm4.21 8.45-7.59-7.59-.707.707 7.59 7.59zm-8.45-4.21 5.07 5.07-.707.708-5.07-5.07zM34.88 25.12v2h-1v-2zm0 13v-2h-1v2zm-5-7v1h-2v-1zm11 1v-1h-2v1zm-3.144-4.804.708.707-1.34 1.34-.707-.707zm-5.982 7.398-.708-.708-1.34 1.34.707.708zm5.35-.708 1.34 1.34-.708.708-1.34-1.34zm-5.35-5.35-1.34-1.34-.708.707 1.34 1.34zm-8.75 2.728a11.11 11.11 0 1 1 3.282 8.156l-.246-.251A11.07 11.07 0 0 1 23 31.69zm16.201 7.82A9.11 9.11 0 1 0 25 31.67l.007.349a9.06 9.06 0 0 0 2.472 5.881l.224.23a9.11 9.11 0 0 0 11.502 1.075M36.95 31.61a2.79 2.79 0 1 1-5.58 0 2.79 2.79 0 0 1 5.58 0",
    clipRule: "evenodd"
  })));
};

export { IconSolarSolutions, IconSolarSolutions as default };
